import { clx_ } from '@@lib/clx';
import css from './home.module.scss';

/**
 * Utils: Home page's clx
 */
const clx = clx_(css);
export default clx;
